import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { AtonUnit, useReimariApi } from "~/api/GeneratedApi";
import GenericTable, {
  CustomColumn,
  CustomTableProps,
} from "~/components/GenericTable";
// import { useDateFormatter } from "~/utils/hooks/useDateFormatter";
import PaddedBox from "~/components/PaddedBox";
import { getAtonLocation } from "~/utils/getAtonLocation";

const AtoNsList = ({
  atonUnits,
  useLocalData = false,
}: {
  atonUnits?: AtonUnit[];
  useLocalData?: boolean;
}): JSX.Element => {
  const { t } = useTranslation("aton");
  const refetchRef = useRef<() => void>();
  const history = useHistory();
  const { getAtonUnits } = useReimariApi();
  // const dateFormatter = useDateFormatter();

  const columns = React.useRef<CustomColumn<AtonUnit>[]>([
    {
      title: t("atonNumber"),
      field: "atonNumber",
    },
    {
      title: t("name"),
      field: "name",
    },
    {
      title: t("type"),
      field: "type",
    },
    {
      title: t("subType"),
      field: "subType",
    },
    {
      title: t("navigationType"),
      field: "navigationType",
    },
    {
      title: t("structureType"),
      field: "structureType",
    },
    {
      title: t("lighting"),
      field: "hasLighting",
      render: ({ hasLighting }) =>
        hasLighting ? <CheckIcon /> : <CloseIcon />,
    },
    {
      title: t("remote-monitoring"),
      field: "seaDaticsRemoteMonitoring",
      render: ({ seaDaticsRemoteMonitoring }) =>
        seaDaticsRemoteMonitoring ? <CheckIcon /> : <CloseIcon />,
    },
    {
      title: t("fairway"),
      field: "mainFairwayId",
    },
    {
      title: t("owner"),
      field: "owner",
    },
  ]);

  const tableProps = React.useRef<CustomTableProps<AtonUnit>>({
    title: t("atons"),
    options: { pageSize: 10, idSynonym: "atonNumber" },

    actions: [
      ({ atonNumber }) => ({
        icon: "visibility",
        tooltip: t("view-aton"),
        isLink: true,
        basePath: () => `/atons/${atonNumber}/details`,
        // onClick: (_, data) => {
        //   if (Array.isArray(data)) return;
        //   history.push(`/atons/${data.atonNumber}/details`);
        // },
      }),
      (rowData) => {
        const location = getAtonLocation(rowData);
        return {
          icon: "map",
          tooltip: !location ? t("no-location") : t("show-on-map"),
          disabled: !location,
          position: "row",

          onClick: (_, rowD) => {
            if ("length" in rowD) return;
            history.push({
              pathname: "/map",
              state: { featureId: `aton${rowD.atonNumber}` },
            });
          },
        };
      },
    ],
  });

  const genTabProps = React.useMemo(() => {
    if (useLocalData) return { data: atonUnits ?? [] };
    return {
      fetch: getAtonUnits,
      getRefetch: (r: () => void) => {
        refetchRef.current = r;
      },
    };
  }, [atonUnits, getAtonUnits, useLocalData]);

  return (
    <PaddedBox>
      <GenericTable<AtonUnit>
        columns={columns.current}
        {...genTabProps}
        tableProps={tableProps.current}
      />
    </PaddedBox>
  );
};

export default AtoNsList;
